/** The Polly voices a customer can hear an announcement in - the neural set Amazon Connect offers, by language. */
export interface PollyVoice {
  id: string;
  language: string;
  gender: "female" | "male";
}

export const POLLY_VOICES: PollyVoice[] = [
  { id: "Joanna", language: "English (US)", gender: "female" },
  { id: "Matthew", language: "English (US)", gender: "male" },
  { id: "Ruth", language: "English (US)", gender: "female" },
  { id: "Stephen", language: "English (US)", gender: "male" },
  { id: "Ivy", language: "English (US)", gender: "female" },
  { id: "Kendra", language: "English (US)", gender: "female" },
  { id: "Kimberly", language: "English (US)", gender: "female" },
  { id: "Salli", language: "English (US)", gender: "female" },
  { id: "Joey", language: "English (US)", gender: "male" },
  { id: "Justin", language: "English (US)", gender: "male" },
  { id: "Kevin", language: "English (US)", gender: "male" },
  { id: "Amy", language: "English (UK)", gender: "female" },
  { id: "Emma", language: "English (UK)", gender: "female" },
  { id: "Brian", language: "English (UK)", gender: "male" },
  { id: "Arthur", language: "English (UK)", gender: "male" },
  { id: "Olivia", language: "English (Australia)", gender: "female" },
  { id: "Aria", language: "English (New Zealand)", gender: "female" },
  { id: "Ayanda", language: "English (South Africa)", gender: "female" },
  { id: "Kajal", language: "English (India)", gender: "female" },
  { id: "Niamh", language: "English (Ireland)", gender: "female" },
  { id: "Lupe", language: "Spanish (US)", gender: "female" },
  { id: "Pedro", language: "Spanish (US)", gender: "male" },
  { id: "Lucia", language: "Spanish (Spain)", gender: "female" },
  { id: "Sergio", language: "Spanish (Spain)", gender: "male" },
  { id: "Mia", language: "Spanish (Mexico)", gender: "female" },
  { id: "Andrés", language: "Spanish (Mexico)", gender: "male" },
  { id: "Léa", language: "French", gender: "female" },
  { id: "Rémi", language: "French", gender: "male" },
  { id: "Gabrielle", language: "French (Canada)", gender: "female" },
  { id: "Vicki", language: "German", gender: "female" },
  { id: "Daniel", language: "German", gender: "male" },
  { id: "Bianca", language: "Italian", gender: "female" },
  { id: "Adriano", language: "Italian", gender: "male" },
  { id: "Camila", language: "Portuguese (Brazil)", gender: "female" },
  { id: "Thiago", language: "Portuguese (Brazil)", gender: "male" },
  { id: "Laura", language: "Dutch", gender: "female" },
  { id: "Takumi", language: "Japanese", gender: "male" },
  { id: "Kazuha", language: "Japanese", gender: "female" },
  { id: "Seoyeon", language: "Korean", gender: "female" },
  { id: "Zhiyu", language: "Chinese (Mandarin)", gender: "female" },
  { id: "Hala", language: "Arabic (Gulf)", gender: "female" },
  { id: "Ola", language: "Polish", gender: "female" },
  { id: "Elin", language: "Swedish", gender: "female" },
  { id: "Ida", language: "Norwegian", gender: "female" },
  { id: "Sofie", language: "Danish", gender: "female" },
  { id: "Suvi", language: "Finnish", gender: "female" },
];
